// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
import Vueaxios from 'vue-axios'
Vue.use(Vueaxios, axios)

import '@/assets/css/reset.css'
import '@/assets/css/common.less'
import commonJS from '@/assets/js/common.js'
import * as echarts from 'echarts';

Vue.prototype.$commonJS = commonJS;
Vue.prototype.$echarts = echarts;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
// 如果引入版本 (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

let load;
// 设置请求拦截器s
axios.interceptors.request.use(config => {
  console.log('config', config.url);
  // console.log(config.url.indexOf("/REC/DATA/SAVE"));
  if (config.url.indexOf("GetToday") < 0 && config.url.indexOf("/REC/DATA/SAVE") < 0) {
    if (!config.headers.Disable) {
      load = ElementUI.Loading.service({
        lock: true,
        background: "rgba(0, 0, 0, 0.2)"
      });
    }
  }
  if (localStorage.getItem('loginToken')) {
    config.headers.Authorization = localStorage.getItem('loginToken')
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 设置响应拦截器
axios.interceptors.response.use(res => {
  load.close()
  return res
}, error => {
  load.close()
  // 如果是正常接口，会走err，err.response.status值为401 进行跳转及删除token的操作
  if (error.response) {
    switch (error.response.status) {
      case 401:

        // 返回 401 清除token信息并跳转到登录页面
        localStorage.removeItem('loginToken')
        if (location.hash != "#/") {
          location.reload();
        }
        // console.log(location)
        // var redirect = window.location.href.split('#')[1]
        // location.reload()
        return Promise.reject("登录已过期,请重新登录");
      case 403:
        localStorage.removeItem('loginToken')
        if (location.hash != "#/") {
          location.reload();
        }
        return Promise.reject("你没权限查询该资源");
      case 404:
        return Promise.reject("你所访问的资源不存在");
      case 500:
        return Promise.reject("服务器出错啦");
    }
  }
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/main.js